import { render, staticRenderFns } from "./DialogueFinish.vue?vue&type=template&id=504048a0&scoped=true&"
import script from "./DialogueFinish.vue?vue&type=script&lang=js&"
export * from "./DialogueFinish.vue?vue&type=script&lang=js&"
import style0 from "./DialogueFinish.vue?vue&type=style&index=0&id=504048a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504048a0",
  null
  
)

export default component.exports